<!-- Step4 劇場前売券/優待券 -->
<template>
  <div class="egl-dialog-elm">
    <el-dialog
      :visible="visible"
      :title="$locale('dailyClosing.createDialog.title')"
      width="90%"
      class="egl-dialog"
      :modal="false"
      :show-close="true"
      :close-on-click-modal="false"
      @close="closeAction"
    >
      <el-form :disabled="isDetailMode" :model="detailData">
        <div class="module-item">
          <!-- 売掛金 and 同額を自動設定 -->
          <el-row :gutter="10">
            <el-col :span="16">
              <h2>{{ $locale("dailyClosing.theaterAdvanceTicketTable.title") }}</h2>
            </el-col>
            <el-col :span="8" class="ta-r">
              <el-button class="egl-btn-yellow" @click="setSameAmount">
                {{ $locale("dailyClosing.theaterAdvanceTicketTable.autoSetSameAmount") }}
              </el-button>
            </el-col>
          </el-row>

          <!-- 全レジ内金額の内訳計算表 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.title") }}</div>
          <AllCashAmounts
            :accountsReceivableType="accountsReceivableType"
            :tableData="detailData.theaterTicket.cashDetails"
            :actionType="actionType"
          ></AllCashAmounts>
          <hr class="dotted">

          <!-- レジ締め済取引の払戻・修正 / 過去営業日取引の追加 -->
          <!-- TODO: how to get this table data? -->
          <template v-if="isShowPastBizDayTrans">
            <div class="module-item-tit">{{ $locale("dailyClosing.theaterAdvanceTicketTable.theaterPastBusinessDayTransactionsTable.title") }}</div>
            <PastBizDayTrans
              :accountsReceivableType="accountsReceivableType"
              :tableData="detailData.theaterTicket.refundUpdateDetails"
              :actionType="actionType"
            ></PastBizDayTrans>
            <hr class="dotted">
          </template>

          <!-- 過不足精算表 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.title") }}</div>
          <TicketReplacement
            :accountsReceivableType="accountsReceivableType"
            :tableData="detailData.theaterTicket.cashDetails"
            :actionType="actionType"
          ></TicketReplacement>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          class="egl-btn-white"
          @click="closeAction(true, false)"
        >{{ $locale("dailyClosing.prevPage") }}</el-button>
        <el-button
          :class="nextBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'"
          :disabled="nextBtnDisabled"
          @click="save_fn"
        >{{ $locale("dailyClosing.createDialog.basicInfo.next") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import CountDownAlert from "@/utils/countDownAlert";

import { saveDayClose } from "@/helpers/service/api/dailyClosingNew";
import { receivableType } from "@/assets/js/dailyClosingNew";
import PastBizDayTrans from "./PastBizDayTrans";
import TicketReplacement from "./TicketReplacement";
import AllCashAmounts from "./AllCashAmounts";

export default {
  name: "TheaterAdvanceTicket",
  components: {
    PastBizDayTrans,
    TicketReplacement,
    AllCashAmounts,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "",
    },
    detailData : {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      accountsReceivableType: receivableType(),
    };
  },
  computed: {
    isDetailMode() {
      return this.actionType === "detail";
    },
    nextBtnDisabled() {
      const { cashDetails } = this.detailData.theaterTicket;
      if (!cashDetails || cashDetails.length === 0) {
        return false;
      }

      const excludedArray = ["details", "paymentType", "settlementId"];

      for (let _key in cashDetails) {
        cashDetails[_key].find(_tArray => {
          Object.entries(_tArray).forEach(_item => {
            if (!excludedArray.includes(_item[0])) {
              if (_item[1] === "" || _item[1] === "undefined" || _item[1] === null || _item[1] === "-") {
                return true;
              }
            }
          });
        });
      }

      return false;
    },
    isShowPastBizDayTrans() {
      if (!this.detailData.theaterTicket || !this.detailData.theaterTicket.refundUpdateDetails) {
        return false;
      }

      let result = true;
      let countsArray = Object.keys(this.detailData.theaterTicket.refundUpdateDetails).map(_key =>
        this.detailData.theaterTicket.refundUpdateDetails[_key].length === 0);

      result = countsArray.includes(false);

      return result;
    },
  },
  watch: {
    visible(_nv) {
      if (_nv) {
        this.restructureData();
      }
    },
  },
  methods: {
    restructureData() {
      if (
        !this.detailData.theaterTicket.cashDetails
        || this.detailData.theaterTicket.cashDetails.length === 0
      ) {
        return [];
      }

      const _cashDetails = tranfResData(this.detailData.theaterTicket.cashDetails);
      const _addPropFn = objArray => {
        objArray.forEach(_item => {
          const { actualAmount, amount, actualSales, dayActualQty, cashQty, actualQty } = _item;
          const _dayQty = dayActualQty - actualQty;
          const _cashBalance = actualAmount - amount;
          const _dayInsufficient = actualSales - actualAmount;

          _item.dayQty = _dayQty;
          _item.cashBalance = _cashBalance;
          _item.saleQty = _cashBalance - _dayInsufficient;
          _item.dayInsufficient = _dayInsufficient;
          _item.insufficientTotal = cashQty + _dayQty;
        });

        return objArray;
      };

      Object.keys(_cashDetails).forEach(_key => {
        if (_cashDetails[_key].length > 0) {
          const _subList = _addPropFn(_cashDetails[_key], _key);
          _cashDetails[_key] = _subList;
        }
      });

      this.$emit("update:detailData", {
        ...tranfResData(this.detailData),
        theaterTicket: {
          ...tranfResData(this.detailData.theaterTicket),
          cashDetails: _cashDetails,
          // refundUpdateDetails: _cashDetails, // TODO: mock data!!!
        },
      });
    },
    closeAction(_goPrevStep = false, _goNextStep = false) {
      this.$emit("closeDialogFn", {
        name: "step4",
        prevStep: _goPrevStep,
        nextStep: _goNextStep,
      });
    },
    setSameAmount() {
      if (typeof this.detailData.theaterTicket.cashDetails === "undefined") {
        return;
      }

      Object.keys(this.detailData.theaterTicket.cashDetails).forEach(_key => {
        this.detailData.theaterTicket.cashDetails[_key].forEach(_list => {
          _list.dayActualQty = _list.actualQty;
          _list.actualSales = _list.actualAmount;
        });
      });
    },
    save_fn() {
      if (this.isDetailMode) {
        this.closeAction();
      } else {
        const { theaterTicket } = tranfResData(this.detailData);
        const requestParam = {
          ...theaterTicket,
          shortage: theaterTicket.cashDetails,
        };

        saveDayClose(requestParam).then(res => {
          if (res.success) {
            this.closeAction();
            CountDownAlert({ content: this.$locale("global.operationSuccessful"), callback: this.$emit("searchFn") });
          }
        });
      }
    },
  },
};
</script>

